<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-clipboard-text-clock-outline
      </v-icon>Transaction List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <br>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            lg="4"
          >
            <v-autocomplete
              v-model="selectedOrganizationId"
              menu-props="auto"
              :items="organizationList"
              item-value="external_id"
              item-text="name"
              label="Select Organization"
              outlined
              dense
              @input="getOrganizationTransactionHistory()"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="OrganizationsTransactionHistory"
        :search="search"
        disable-sort
        class="elevation-1"
        mobile-breakpoint="100"
      >
        <template #item="{ item }">
          <tr>
            <td>
              {{ item.payment_date | convertToLocal }}
            </td>
            <td>
              {{ item.plan }}
            </td>
            <td class="period-style">
              {{ item.period }}
            </td>
            <td>
              <v-chip
                color="#37474F"
                small
                outlined
                dark
              >
                {{ item.quantity }}
              </v-chip>
            </td>
            <td>
              <span class="currency-style">{{ item.currency }}</span> {{ item.amount | convertAmount }}
            </td>
            <td>
              {{ item.current_period_end | convertToLocal }}
            </td>
            <td>
              <font
                :color="statusColor(item.stripe_status)"
                class="font-my-style"
              >
                {{ item.stripe_status | statusUpdate }}
              </font>
            </td>
            <td>
              {{ item.payment_by }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="py-3" />
    </v-card>
    <v-btn
      v-if="showAllTransactionHistory"
      color="red darken-3"
      @click="back()"
    >
      Back
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
 <script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  export default {
    name: 'OrganizationsTransactionList',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (subscriptionStatus) {
        if (subscriptionStatus === 'active' || subscriptionStatus === 'succeeded') {
          return 'Completed*';
        } else {
          return 'N/A';
        }
      },
      convertAmount (amount) {
        return amount / 100;
      },
    },
    data () {
      return {
        search: '',
        headers: [
          { text: 'Payment Date', align: 'start', value: 'payment_date' },
          { text: 'Plan', value: 'plan' },
          { text: 'Plan Period', value: 'period' },
          { text: 'Quantity', value: 'quantity' },
          { text: 'Amount (Tax Incl.)', value: 'amount' },
          { text: 'Ends At', value: 'current_period_end' },
          { text: 'Status', value: 'stripe_status' },
          { text: 'Payment By', value: 'payment_by' },
        ],
        loading: false,
        selectedOrganizationId: '',
      };
    },
    computed: {
      OrganizationsTransactionHistory () {
        return this.$store.getters['payments/getOrganizationsTransactionList'];
      },
      organizationList () {
        return this.$store.getters['organizations/getOrganizationList'];
      },
      showAllTransactionHistory () {
        if (this.selectedOrganizationId === '' || this.selectedOrganizationId === null) {
          return false;
        }
        return true;
      },
    },
    async mounted () {
      await this.getOrganizationsTransactionHistory();
      await this.getOrganizationslist();
    },
    methods: {
      async getOrganizationsTransactionHistory () {
        this.loading = true;
        await this.$store.dispatch('payments/fetchOrganizationsTransactionList');
        this.loading = false;
      },
      async getOrganizationslist () {
        this.loading = true;
        await this.$store.dispatch('organizations/fetchOrganizationList');
        this.loading = false;
      },
      statusColor (status) {
        if (status === 'active' || status === 'succeeded') {
          return '#2E7D32';
        } else {
          return '#C62828';
        }
      },
      async getOrganizationTransactionHistory () {
        this.loading = true;
        await this.$store.dispatch('payments/fetchOrganizationTransactionList', {
          params: {
            organizationId: this.selectedOrganizationId,
          },
        });
        this.loading = false;
      },
      back () {
        this.selectedOrganizationId = '';
        this.getOrganizationsTransactionHistory();
      },
    },
  };
</script>
<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.font-my-style {
  font-weight: bold;
}
.period-style {
  text-transform: capitalize;
}
.currency-style {
  color: #FF3700;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 12px;
}
</style>
